import { request } from '@/request'
import { formatObjectToQueryString as str } from '@/utils/strings'
import colors from '@/utils/colors'
import {
  PublicHeader,
  BarChart,
  LineChart2 as LineChart
} from '@/components/common/'

export default {
  inject: ['showConfirm'],
  name: 'Favoritos',
  components: {
    PublicHeader,
    BarChart,
    LineChart
  },
  data() {
    return {
      favoritos: [],
      dados: [],
      comparativos: [],
      cores: colors.coresHexa,
      tipoGrafico: 'bar',
      tipoComparativo: 'soma'
    }
  },
  methods: {
    fetchFavoritos() {
      request
        .get(
          'favoritos?' +
            str(JSON.parse(localStorage.getItem('pmsdadosabertos')).favoritos)
        )
        .then(response => {
          this.favoritos = response.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    removerFavorito(favorito) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          const { favoritos, ...rest } = JSON.parse(
            localStorage.getItem('pmsdadosabertos')
          )

          if (favoritos.length) {
            const index = favoritos.indexOf(favorito.codigo)
            favoritos.splice(index, 1)
            localStorage.setItem(
              'pmsdadosabertos',
              JSON.stringify({ ...rest, favoritos })
            )
          }

          this.fetchFavoritos()

          this.$toastr.s('Favorito removido com sucesso')
        }
      }

      this.showConfirm('Deseja realmente remover este item?', config)
    },
    toDate(dateStr) {
      const [day, month, year] = dateStr.split('/')
      return new Date(year, month - 1, day)
    },
    adicionarComparativo(id, nome) {
      request
        .get('favoritos/valores/' + id)
        .then(response => {
          const { datas, valores } = response.data

          this.dados.push({
            codigo: id,
            nome: nome,
            valores: valores,
            datas: datas
          })

          let aux = {}
          for (let index = 0; index < datas.length; index++) {
            const data_dado = this.toDate(datas[index])
            aux[data_dado.getFullYear()] = valores[index]
          }

          this.comparativos.push(aux)
        })
        .catch(error => {
          this.$toastr.e(error.response)
        })
    },
    removerComparativo(item) {
      this.dados.splice(item, 1)
      this.comparativos.splice(item, 1)
    },
    permitirComparativo(favorito) {
      if (
        favorito.tipo === 'T' ||
        this.dados.findIndex(val => val.codigo === favorito.codigo) > -1 ||
        this.dados.length > 4
      ) {
        return false
      }

      return true
    },
    retornaSoma(grafico) {
      let result = [...this.comparativos]
      const anos = grafico.labels

      grafico.datasets.push({
        label: 'Soma Simples',
        data: []
      })

      result = result.reduce((acumulador, atual) => {
        let res = {}
        for (let index = 0; index < anos.length; index++) {
          res[anos[index]] =
            (parseFloat(acumulador[anos[index]]) || 0) +
            (parseFloat(atual[anos[index]]) || 0)
        }

        return res
      })

      for (let index = 0; index < anos.length; index++) {
        grafico.datasets[0].data.push(result[anos[index]])
      }

      return grafico
    },
    retornaMediaSimples(grafico) {
      let result = this.retornaSoma(grafico)
      result.datasets[0].label = 'Média simples'
      result.datasets[0].data = result.datasets[0].data.map(
        valor => valor / this.comparativos.length
      )

      return result
    },
    retornaMediaAnual(grafico) {
      const base = [...this.comparativos]
      let result = {
        ...grafico,
        labels: ['Média Anual']
      }

      // varrendo todos os objetos da variável base
      for (let index = 0; index < base.length; index++) {
        // pegando os anos de cada objeto
        const anos = Object.keys(base[index])
        let acumulador = 0

        // varrendo o array de anos para somar os valores do objeto que está em iteração
        for (let subindex = 0; subindex < anos.length; subindex++) {
          acumulador += parseFloat(base[index][anos[subindex]]) || 0
        }

        // adicionando o resultado da soma na estrutura do gráfico
        result.datasets.push({
          label: `Dado ${index + 1}`,
          data: [acumulador / anos.length]
        })
      }

      return result
    },
    retornaRelacao(grafico) {
      let result = { ...grafico }
      const anos = result.labels
      let base = []

      for (let index = 0; index < 2; index++) {
        base.push({ ...this.comparativos[index] })
      }

      let relacao = base.reduce((acumulador, atual) => {
        let res = []
        for (let index = 0; index < anos.length; index++) {
          res.push(
            (parseFloat(acumulador[anos[index]]) || 0) /
              (parseFloat(atual[anos[index]]) || 1)
          )
        }

        return res
      })

      result.datasets.push({
        label: 'Relação Dado 1 / Dado 2',
        data: relacao
      })

      return result
    }
  },
  mounted() {
    this.fetchFavoritos()
  },
  computed: {
    labels_grafico() {
      const base = [2014]
      const periodicidade = this.favoritos[
        this.favoritos.findIndex(val => val.codigo === this.dados[0].codigo)
      ].periodicidade

      if (periodicidade === 6) {
        let data = new Date()
        while (base[base.length - 1] < data.getFullYear() - 1) {
          base.push(base[base.length - 1] + 1)
        }
      }

      return base
    },
    dados_grafico() {
      const anos = this.labels_grafico
      const dados = [...this.comparativos]
      let base = {
        labels: this.labels_grafico,
        datasets: []
      }

      for (let index = 0; index < dados.length; index++) {
        base.datasets.push({
          label: '',
          data: []
        })

        for (let subindex = 0; subindex < anos.length; subindex++) {
          base.datasets[index].data.push(dados[index][anos[subindex]])
        }
      }

      return base
    },
    dados_comparativos() {
      let grafico = {
        labels: this.labels_grafico,
        datasets: []
      }

      switch (this.tipoComparativo) {
        case 'soma':
          return this.retornaSoma(grafico)
        case 'mediaSimples':
          return this.retornaMediaSimples(grafico)
        case 'mediaAnual':
          return this.retornaMediaAnual(grafico)
        case 'relacao':
          return this.retornaRelacao(grafico)
        default:
          return grafico
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/favoritos/favoritos.js